/**
 * Attempts to focus an element or the first focusable child within it.
 * @param {HTMLElement} el - The element to focus.
 */
export const tryFocus = (el) => {
	const selector = `
        input:not([tabindex^="-"]):not([disabled]),
        select:not([tabindex^="-"]):not([disabled]),
        textarea:not([tabindex^="-"]):not([disabled]),
        button:not([tabindex^="-"]):not([disabled]),
        a[href]:not([tabindex^="-"]):not([disabled]),
		[contenteditable="true"]:not([tabindex^="-"]):not([disabled]),
        [tabindex]:not([tabindex^="-"]):not([disabled])
	`;

	const targetEl = el.matches(selector)
		? el : el.querySelector(selector);

	if (!targetEl) {
		return;
	}

	targetEl.focus();
};
